module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-actions-5c41126608e011218b1ebda3ee10d1af.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-actions.jpg
// module id = 343
// module chunks = 2